import React, { useEffect, useState } from 'react';
import { Card, Tabs } from 'antd';
import AddFeeDiscard from './AddFeeDiscard';
import ListFeeDiscard from './ListFeeDiscard';

export default function FeeDiscardWrapper() {
    const { TabPane } = Tabs;

    return (
        <>
            <Card title="Fee Head Remove">
                <Tabs defaultActiveKey="1">
                    <TabPane tab="Remove" key="1">
                        <AddFeeDiscard />
                    </TabPane>
                    <TabPane tab="Removed List" key="2">
                    <ListFeeDiscard />
                    </TabPane>
                </Tabs>
            </Card>
        </>
    )
}